var _rect, _rect2, _circle, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 320,
    viewBox: "0 0 480 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 320,
    fill: "#f5f5f5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 400,
    height: 240,
    rx: 24,
    fill: "#e5e7eb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 150,
    r: 36,
    fill: "#cbd5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 230l60-70 60 55 70-80 70 95H110z",
    fill: "#93c5fd"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 250,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#6b7280"
  }, "Asset unavailable")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetPlaceholder);
export default __webpack_public_path__ + "static/media/asset-placeholder.711900b0efe31b083191d50dee3daeba.svg";
export { ForwardRef as ReactComponent };